import React from 'react';
import ProposalTitle from './ProposalTitle';
import TitleLevelField from '../../../puck/fields/TitleLevelField';
import { puckVisibilityField } from '../../../puck/fields/puckVisibilityField';
import { puckHorizontalAlignField } from '../../../puck/fields/puckHorizontalAlignField';
import { puckVerticalAlignField } from '../../../puck/fields/puckVerticalAlignField';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import { puckSectionField } from '../../../puck/fields/puckSectionField';
import { proposalHeadingBackground } from '../../../utils/proposalTextStyle';

const proposalTitleConfig = {
  label: 'Titre',
  defaultProps: {
    html: '<h2></h2>',
    titleLevel: 2,
    isVisible: true,
    alignHorizontal: 'end',
    alignVertical: 'center',
  },
  fields: {
    isVisible: puckVisibilityField(),

    _section1: puckSectionField('Style'),
    /* Le fond vient de la configuration des titres du document : il se règle
       ici, ou nulle part. */
    backgroundColor: puckColorField('Couleur de fond', {
      allowTransparent: true,
      /* Tant que rien n'est choisi, le bloc porte le fond posé par le proposal
         à la génération : le champ affiche cette couleur-là, celle qui est
         réellement rendue, au lieu d'un blanc que personne n'a choisi. */
      emptyIsInherited: true,
      readInherited: (props, { proposalStyles }) => (
        props?.textStyle?.backgroundColor
        || proposalHeadingBackground(proposalStyles, props?.titleLevel ?? 2)
        || ''
      ),
    }),

    _section2: puckSectionField('Affichage'),
    titleLevel: {
      type: 'custom',
      label: 'Niveau de titre',
      render: ({ value, onChange }) => (
        <TitleLevelField value={value} onChange={onChange} />
      ),
    },
    /* Les deux props étaient déjà lues par le rendu, sans champ pour les
       régler : le titre s'alignait donc toujours comme il avait été généré. */
    alignHorizontal: puckHorizontalAlignField(),
    alignVertical: puckVerticalAlignField(),
  },
  render: (props) => <ProposalTitle {...props} />,
};

export default proposalTitleConfig;
